import {
  FinancialHighlightsModel,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class OwnershipConfiguration extends ReportSectionConfigurationBase {
  typeName = 'OwnershipConfiguration';
  nodataLocalizationKeyName = 'ownership';
  readonly reportSection = ReportSection.FinancialHighlights;
  readonly applicableReportTypes = [ReportType.Contact, ReportType.Institution];
  readonly reportViewModelSections = [ReportViewModelSection.InvestorProfile_FinancialHighlights];
  minSize = 2;
  maxSize = 4;
  defaultSize = 2;
  name = 'ownership';
  readonly availableDataSections = [
    {
      name: 'ownershipReportedShares',
      displayName: 'Reported Shares',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'ownershipValue',
      displayName: 'Value USD, mm',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'ownershipPctSO',
      displayName: '% S/O',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'ownershipHolderPctPortfolio',
      displayName: '% Portfolio',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'ownershipHolderRank',
      displayName: 'Current Holder Rank',
      isSelected: true,
      canConfigure: true
    },
    {
      name: 'ownershipShareChange',
      displayName: 'Share Change',
      isSelected: false,
      canConfigure: true
    },
    {
      name: 'ownershipMarketValueChange',
      displayName: 'Market Value Change USD, mm',
      isSelected: false,
      canConfigure: true
    },
    {
      name: 'ownershipShareValueChange',
      displayName: 'Share Change Value USD, mm',
      isSelected: false,
      canConfigure: true
    }
  ];

  get displayName(): string {
    if (this.appliedReportType === ReportType.Contact || this.appliedReportType === ReportType.Institution) {
      return 'Ownership';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface OwnershipData {
  [ReportViewModelSection.InvestorProfile_FinancialHighlights]: FinancialHighlightsModel;
}
